<pr-table
  [headerTitle]="'Historique des évènements'"
  [columnsDefinition]="eventsColumnsDefinition"
  [data]="eventsTableData"
  [swiperMinWidth]="992"
  [showLoader]="loading"
  class="mbl"
>
  <span emptyTemplate>Aucun événement</span>
</pr-table>
